import { ExternalLink } from "lucide-react";
import { C } from "../../theme/tokens";
import { REG_LINK, REG_LINK_RU, isRussianTimezone } from "../../data/referralLinks";

/* Referral registration button: picks the Russian mirror or the main
   link by device timezone, with the other one offered underneath in
   case the guess is wrong (VPN, travelling, etc.). */
export function RegLinkButton({ t, label }) {
  const ru = isRussianTimezone();
  const primary = ru ? REG_LINK_RU : REG_LINK;
  const alternative = ru ? REG_LINK : REG_LINK_RU;

  return (
    <>
      <a
        href={primary}
        target="_blank"
        rel="noreferrer"
        style={{
          marginTop: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          textDecoration: "none",
          padding: "15px 18px",
          borderRadius: 14,
          background: `linear-gradient(120deg, ${C.greenBright} 0%, ${C.green} 100%)`,
          color: "#0b0d13",
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 700,
          fontSize: 15,
        }}
      >
        {label}
        <ExternalLink size={16} />
      </a>
      <a
        href={alternative}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "block",
          marginTop: 8,
          textAlign: "center",
          color: C.mutedB,
          fontSize: 12.5,
          textDecoration: "underline",
        }}
      >
        {ru ? t.reg_link_alt_main : t.reg_link_alt_ru}
      </a>
    </>
  );
}
